function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.971 16.716a2.24 2.24 0 11-4.478 0 2.24 2.24 0 014.477 0zm-15.673 0a2.24 2.24 0 11-4.478.002 2.24 2.24 0 014.478-.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.971 16.716h1.677c.618 0 1.12-.5 1.12-1.119v-4.46a1.12 1.12 0 00-.47-.913L22.851 8.88l-.908-4.75a1.12 1.12 0 00-1.086-.847h-4.163v-1.12a1.12 1.12 0 00-1.12-1.12H2.142a1.12 1.12 0 00-1.12 1.12v13.433c0 .618.502 1.12 1.12 1.12h1.679m15.671 0H8.298m8.396-13.432v11.194m10.075-1.12H25.09m-2.239-4.477h-6.157"
}));

function SvgWorkflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20
  }, props), _ref);
}

export default SvgWorkflow;